/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface ErasureRequestOut {
  erasure_request_id: string;
  status: string;
  subject_kind: string;
  conversations_total: number;
  conversations_done: number;
  blocked_conversation_ids: string[];
  requested_at: string;
  completed_at: string | null;
  is_dsar: boolean;
}
